import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    getProjectAllWhiteboard,
    getProjectWhiteboard,
    addProjectWhiteboard,
    addNewProjectWhiteboard,
    addWhiteboardComment,
    getWhiteboardComments,
    removeWhiteboardComments,
    editWhiteboardComment,
    removeWhiteboardAllComments,
    removeProjectWhiteboard
} from "../../../services/WhiteboardService";

export const fetchProjectAllWhiteboard = createAsyncThunk(
    'projects/fetchProjectAllWhiteboard',
    async (id) => {
        return getProjectAllWhiteboard(id);
    }
)

export const fetchProjectWhiteboard = createAsyncThunk(
    'projects/fetchProjectWhiteboard',
    async ({project_id, data}) => {
        return getProjectWhiteboard(project_id, data);
    }
)

export const createProjectWhiteboard = createAsyncThunk(
    'projects/createProjectWhiteboard', 
    async ({project_id, data}) => {
        return addNewProjectWhiteboard(project_id, data);
    }
)

export const saveProjectWhiteboard = createAsyncThunk(
    'projects/saveProjectWhiteboard', 
    async ({project_id, whiteboard_id, data}) => {
        return addProjectWhiteboard(project_id, whiteboard_id, data);
    }
)

export const deleteProjectWhiteboard = createAsyncThunk(
    'projects/deleteProjectWhiteboard', 
    async ({project_id, whiteboard_id}) => {
        return removeProjectWhiteboard(project_id, whiteboard_id);
    }
)

export const saveWhiteboardComment = createAsyncThunk(
    'projects/saveWhiteboardComment', 
    async ({project_id, whiteboard_id, data}) => {
        return addWhiteboardComment(project_id, whiteboard_id, data);
    }
)

export const fetchWhiteboardComments = createAsyncThunk(
    'projects/fetchWhiteboardComments',
    async ({project_id, whiteboard_id}) => {
        return getWhiteboardComments(project_id, whiteboard_id);
    }
)

export const deleteWhiteboardComments = createAsyncThunk(
    'projects/deleteWhiteboardComments',
    async ({ project_id, whiteboard_id, data }) => {
        return removeWhiteboardComments(project_id, whiteboard_id, data);
    }
)

export const deleteWhiteboardAllComments = createAsyncThunk(
    'projects/deleteWhiteboardAllComments',
    async ({ project_id, whiteboard_id, data }) => {
        return removeWhiteboardAllComments(project_id, whiteboard_id, data);
    }
)

export const updateWhiteboardComment = createAsyncThunk(
    'projects/updateWhiteboardComment', 
    async ({project_id, whiteboard_id, data}) => {
        return editWhiteboardComment(project_id, whiteboard_id, data);
    }
)


const initialState = {
    licenseKey:'',
    isLoading: false,
    isError: false,
    isLicenseError: false,
    error: null,
    licenseSuccessMessage: null,
    allWhiteboard:[],
    projectWhiteboard:{},
    projectWhiteboardCopy:{},
    projectWhiteboardComments:[],
    loggedInUser: {},
}

const whiteboardSlice = createSlice({
    name: 'whiteboard',
    initialState,
    reducers: {
        removeSuccessMessage: (state) => {
            state.licenseSuccessMessage = null
        },
        removeErrorMessage: (state) => {
            state.error = ''
            state.isLicenseError = false
        },
        setLoggedInUser: (state, action) => {
            state.loggedInUser = action.payload
        },
        updateWhiteboardCopy: (state, action) => {
            state.projectWhiteboardCopy = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjectAllWhiteboard.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(fetchProjectAllWhiteboard.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.allWhiteboard = action.payload && action.payload.data 
            })
            .addCase(fetchProjectAllWhiteboard.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(fetchProjectWhiteboard.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(fetchProjectWhiteboard.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboard = action.payload && action.payload.data && action.payload.data
            })
            .addCase(fetchProjectWhiteboard.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(saveProjectWhiteboard.pending, (state) => {
                state.isLoading = false
                state.isError = false
            })
            .addCase(saveProjectWhiteboard.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboard = action.payload.data
                state.projectWhiteboardCopy = action.payload.data
            })
            .addCase(saveProjectWhiteboard.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(deleteProjectWhiteboard.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(deleteProjectWhiteboard.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                const data = action.payload?.data;
                
                if (Array.isArray(data) && data.length > 0) {
                    state.allWhiteboard = data;
                }
            })
            .addCase(deleteProjectWhiteboard.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(saveWhiteboardComment.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(saveWhiteboardComment.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboardComments = action.payload.data
            })
            .addCase(saveWhiteboardComment.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(fetchWhiteboardComments.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(fetchWhiteboardComments.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboardComments = action.payload && action.payload.data 
            })
            .addCase(fetchWhiteboardComments.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(deleteWhiteboardComments.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(deleteWhiteboardComments.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboardComments = action.payload && action.payload.data 
            })
            .addCase(deleteWhiteboardComments.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(deleteWhiteboardAllComments.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(deleteWhiteboardAllComments.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboardComments = action.payload && action.payload.data 
            })
            .addCase(deleteWhiteboardAllComments.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })
            .addCase(updateWhiteboardComment.pending, (state) => {
                state.isLoading = true
                state.isError = false
            })
            .addCase(updateWhiteboardComment.fulfilled, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.projectWhiteboardComments = action.payload && action.payload.data 
            })
            .addCase(updateWhiteboardComment.rejected, (state, action) => {
                state.isLoading = false
                state.isError = false
                state.error = action.error?.message
            })

    },
})
export const {
    removeSuccessMessage,
    removeErrorMessage,
    setLoggedInUser,
    updateWhiteboardCopy
} = whiteboardSlice.actions
export default whiteboardSlice.reducer
